import React from 'react';
import { useQuill } from '../../../QuillContext';
import ToolbarCommentButton from './comments/ToolbarCommentButton';
import ToolbarReactionButton from './comments/ToolbarReactionButton';
import { ToolbarButtonGroup } from './ToolbarButton';

interface ToolbarCommentButtonGroupProps {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blot?: any;
  existingComment?: string[] | null;
  onReactionPickerOpenChange?: (open: boolean) => void;
  onCommentButtonClick?: () => void;
}

const ToolbarCommentButtonGroup = ({
  blot,
  existingComment,
  onReactionPickerOpenChange,
  onCommentButtonClick,
}: ToolbarCommentButtonGroupProps) => {
  const { quill } = useQuill();

  return quill?.scroll.query('comment') ? (
    <ToolbarButtonGroup>
      <ToolbarReactionButton
        blot={blot}
        onPickerOpenChange={onReactionPickerOpenChange}
      />
      <ToolbarCommentButton
        blot={blot}
        existingComment={existingComment}
        onClick={onCommentButtonClick}
      />
    </ToolbarButtonGroup>
  ) : null;
};

export default ToolbarCommentButtonGroup;
